import { appConfig } from '../../../config/config.app';
import { ensureTransientToken } from '../../../utils/auth/ensureTransientToken';
import { throwIfStepUpChallenge } from '../../../utils/auth/stepUpChallenge';
import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { get } from '../../http';

export const checkUser = async (email: string, aroIdMeStepUpEnabled = false) => {
  try {
    await ensureTransientToken();
    const url = `${appConfig.guidedSignInApiUrl}/guided-sign-in?email=${encodeURIComponent(email)}`;
    const rawResponse = await get(url);
    throwIfStepUpChallenge(rawResponse.status, rawResponse.headers, aroIdMeStepUpEnabled);
    const response = await rawResponse.json();
    evaluateResponseErrorCode(response);
    return response;
  } catch (error) {
    throw getApiError(error);
  }
};
